<div *ngIf="loading" [style.height]="height" [style.width]="width" class="skeleton"></div>
<ng-content *ngIf="!loading"></ng-content>

